import { render, staticRenderFns } from "./PaymentMultipleItems.vue?vue&type=template&id=cc0b0816&scoped=true"
import script from "./PaymentMultipleItems.vue?vue&type=script&lang=js"
export * from "./PaymentMultipleItems.vue?vue&type=script&lang=js"
import style0 from "./PaymentMultipleItems.vue?vue&type=style&index=0&id=cc0b0816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b0816",
  null
  
)

export default component.exports